<template>
  <div class="overflow-auto position-relative">

    <!-- Loader -->
    <div v-if="isLoading" class="loader">
      <!-- You can use a spinner or any other loader here -->
      <font-awesome-icon v-if="isLoading" icon="spinner" class="spinner"/>
      <!--        <div class="spinner"></div>-->
    </div>

    <!-- Content -->
    <div :class="{ 'fade-content': isLoading }">
      <div v-if="isLoader && mobile_screen">
        <div class="loader_responsive">
          <b-skeleton-wrapper>
            <div style="display:flex; flex-direction:row">
              <b-col cols="4" height="120px" style="background-color: #e7eef3 !important;height:33px"></b-col>
              <b-col cols="3" height="120px"
                     style="margin-left:4%; background-color: #e7eef3 !important;height:33px;"></b-col>
              <b-col cols="2" height="120px"
                     style="margin-left:2%; background-color: #e7eef3 !important;height:33px;"></b-col>
              <b-col cols="2" height="120px"
                     style="margin-left:1%; background-color: #e7eef3 !important;height:33px"></b-col>
            </div>
            <div style="display:flex; flex-direction:row">
              <b-col cols="3" height="120px"
                     style="margin-top:4px; margin-bottom:4px; background-color: #e7eef3 !important;height:33px"></b-col>
              <b-col cols="3" height="120px"
                     style="margin-top:4px; margin-bottom:4px;  margin-left:3%; background-color: #e7eef3 !important;height:33px;"></b-col>
              <b-col cols="3" height="120px"
                     style="margin-top:4px; margin-bottom:4px; margin-left:3%; background-color: #e7eef3 !important;height:33px;"></b-col>
              <b-col cols="2" height="120px"
                     style="margin-top:4px; margin-bottom:4px;  margin-left:2%; background-color: #e7eef3 !important;height:33px"></b-col>
            </div>
          </b-skeleton-wrapper>
        </div>
        <div class="loader_responsive mt-2">
          <b-skeleton-wrapper>
            <div style="display:flex; flex-direction:row">
              <b-col cols="4" height="120px" style="background-color: #e7eef3 !important;height:33px"></b-col>
              <b-col cols="3" height="120px"
                     style="margin-left:4%; background-color: #e7eef3 !important;height:33px;"></b-col>
              <b-col cols="2" height="120px"
                     style="margin-left:2%; background-color: #e7eef3 !important;height:33px;"></b-col>
              <b-col cols="2" height="120px"
                     style="margin-left:1%; background-color: #e7eef3 !important;height:33px"></b-col>
            </div>
            <div style="display:flex; flex-direction:row">
              <b-col cols="3" height="120px"
                     style="margin-top:4px; margin-bottom:4px; background-color: #e7eef3 !important;height:33px"></b-col>
              <b-col cols="3" height="120px"
                     style="margin-top:4px; margin-bottom:4px;  margin-left:3%; background-color: #e7eef3 !important;height:33px;"></b-col>
              <b-col cols="3" height="120px"
                     style="margin-top:4px; margin-bottom:4px; margin-left:3%; background-color: #e7eef3 !important;height:33px;"></b-col>
              <b-col cols="2" height="120px"
                     style="margin-top:4px; margin-bottom:4px;  margin-left:2%; background-color: #e7eef3 !important;height:33px"></b-col>
            </div>
          </b-skeleton-wrapper>
        </div>
        <div class="loader_responsive mt-2">
          <b-skeleton-wrapper>
            <div style="display:flex; flex-direction:row">
              <b-col cols="4" height="120px" style="background-color: #e7eef3 !important;height:33px"></b-col>
              <b-col cols="3" height="120px"
                     style="margin-left:4%; background-color: #e7eef3 !important;height:33px;"></b-col>
              <b-col cols="2" height="120px"
                     style="margin-left:2%; background-color: #e7eef3 !important;height:33px;"></b-col>
              <b-col cols="2" height="120px"
                     style="margin-left:1%; background-color: #e7eef3 !important;height:33px"></b-col>
            </div>
            <div style="display:flex; flex-direction:row">
              <b-col cols="3" height="120px"
                     style="margin-top:4px; margin-bottom:4px; background-color: #e7eef3 !important;height:33px"></b-col>
              <b-col cols="3" height="120px"
                     style="margin-top:4px; margin-bottom:4px;  margin-left:3%; background-color: #e7eef3 !important;height:33px;"></b-col>
              <b-col cols="3" height="120px"
                     style="margin-top:4px; margin-bottom:4px; margin-left:3%; background-color: #e7eef3 !important;height:33px;"></b-col>
              <b-col cols="2" height="120px"
                     style="margin-top:4px; margin-bottom:4px;  margin-left:2%; background-color: #e7eef3 !important;height:33px"></b-col>
            </div>
          </b-skeleton-wrapper>
        </div>
      </div>
      <table class="table table-hover" id="dataTable" width="100%" cellspacing="0">
        <thead id="support_table_header">
        <tr>
          <th>Title</th>
          <th>{{ isMyTask ? 'Assign To' : 'Assigned By'}}</th>
          <th>Due Date</th>
          <th>Created At</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody id="table_body">
        <tr v-if="isLoader && !mobile_screen" id="table_row">
          <td colspan="8 ">
            <b-skeleton-wrapper>
              <b-skeleton height="40px"></b-skeleton>
              <b-skeleton height="40px"></b-skeleton>
              <b-skeleton height="40px"></b-skeleton>
            </b-skeleton-wrapper>
          </td>
        </tr>
        <tr v-show="!isLoader" v-for="(quickTask) in quickTasks" :demo="quickTask" :key="quickTask.id" id="table_row">
          <td>
            <span id="td_span">Title</span>
            <div>
              <i v-if="mobile_screen && quickTask.title.length > 16" :id="'title'+quickTask.id"
                 class="fa fa-info-circle tooltip_color float-right" data-html="true" data-toggle="m-tooltip"
                 data-placment="right" title=""></i>
              <p :id="'title'+quickTask.id">{{ quickTask.title }} </p>
              <b-tooltip v-if="mobile_screen && quickTask.title.length > 16" :target="'title'+quickTask.id"
                         placement="bottom" style="">
                {{ quickTask.title }}
              </b-tooltip>
            </div>

          </td>
          <td>
            <span id="td_span">
              {{ isMyTask ? 'Assign To' : 'Assigned By' }}
            </span>
            <div>
              <p>
                {{ isMyTask ? quickTask.assigned_to.name : quickTask.created_by.name }}
              </p>
            </div>
          </td>

          <td>
            <span id="td_span">Due Date</span>
            <p>{{ quickTask.due_date }} {{ quickTask.time }}</p>
          </td>
          <!-- <td>
            <span id="td_span">Time</span>
            <p>{{ quickTask.time }}</p>
          </td> -->
          <td>
            <span id="td_span">Created At</span>
            <p>{{ quickTask.created_at }}</p>
          </td>

          <!-- Status -->
          <td>
            <div id="responsive_status">
              <span v-if="quickTask.status == 0">Pending</span>
              <span v-else-if="quickTask.status == 1">Completed</span>
            </div>
          </td>
          <td>
            <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
              <span class="fas fa-ellipsis-v" id="action_button"></span>
            </a>
            <ul class="dropdown-menu style-action hide-menu">
              <template>
                <li><a class="dropdown-item" :data-id="quickTask.id" @click="quickView"> View</a></li>
                <li v-if="quickTask.status == 0"><a class="dropdown-item" :data-id="quickTask.id" @click="edit">
                  Edit</a></li>
                <li v-if="quickTask.status == 0"><a class="dropdown-item" :data-id="quickTask.id"
                                                    @click="markCompleted(quickTask)">Complete</a></li>
                <li v-if="quickTask.status == 1"><a class="dropdown-item" :data-id="quickTask.id"
                                                    @click="markCompleted(quickTask)">Pending</a></li>
                <!--                <li v-if="quickTask.status == 0" class="quick-task-item">-->
                <!--                  Complete-->
                <!--                  <input-->
                <!--                      type="checkbox"-->
                <!--                      name="mark_completed"-->
                <!--                      id="mark_completed"-->
                <!--                      :checked="quickTask.status === 1"-->
                <!--                      @change="markCompleted(quickTask)"-->
                <!--                      class="quick-task-checkbox"-->
                <!--                  >-->
                <!--                </li>-->
                <li><a class="dropdown-item" :data-id="quickTask.id" @click="deleteTask(quickTask.id)">Delete</a></li>
              </template>
            </ul>
          </td>
        </tr>
        </tbody>
      </table>

      <h5 style="text-align: center" v-if="quickTasks.length < 1 && !isLoader">No data found.</h5>
      <div v-if="!isLoader" class="container border-top" id="font_size" style="font-size: 14px; bottom: 0">
        <div class="row mt-1 justify-content-end d-flex align-items-center px-3">
          <paginate v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''"
                    :next-text="''"
                    :first-button-text="''" :last-button-text="''" :first-last-button="true"
                    :container-class="'pagination pagination-sm float-right mb-2 mr-4 mb-0'" :page-class="'page-item'"
                    :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'"
                    :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
          <span class=" float-right mb-2 mr-4 mb-0 display-rows"
                style="color:#48a6a6;">Display Rows: <b>{{ totalTaskRows }}</b></span>
          <span class=" float-right mb-2 mr-4 mb-0 display-rows"
                style="color:#48a6a6;">Total Tasks: <b>{{ totalRecords }}</b></span>
          <div v-if="totalPages>0" class="change_page float-right" style="display :none;">
            <a href="#" @click="previousPage" class="previous">&laquo; Previous</a>
            <a href="#" @click="nextPage" class="next">Next &raquo;</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import taskForm from "@/components/QuickTask/add.vue";
import quickView from "@/components/QuickTask/view.vue";

export default {
  props: {
    quickTasks: Array,
    total_quick_task: Number,
    totalRows: Number,
    displayed_tickets: Number,
    totalPages: Number,
    page: Number,
    selTab: String,
    setskeletonLoader: Boolean,
  },
  data: function () {
    return {
      board_lists: [],
      selected_ticket_key: "",
      taskForm: {
        ticket_id: "",
        list_id: "",
        list_card_title: "",
        list_card_desc: "",
      },
      mobile_screen: false,
      isLoader: true,
      tpm: [],
      isLoading: false
    };
  },

  computed: {

    isMyTask() {
      return this.$route.meta.taskType === 'myTask';
    },

    currentPage: {
      get: function () {
        return this.page;
      },
      set: function () {
      },
    },

    totalRecords: function () {
      return this.$store.getters["quick_task/totalRecords"];
    },

    totalTaskRows: function () {
      return this.$store.getters['quick_task/totalRows']
    },
    showskLoader: function () {
      this.isLoader = this.setskeletonLoader;
      return this.setskeletonLoader;
    },
    search: function () {
      return this.$store.getters['quick_task/search'];
    },
  },
  watch: {
    showskLoader() {
      this.isLoader = this.setskeletonLoader;
      return this.setskeletonLoader;
    }
  },
  created: function () {
    if ($(window).width() > 319 && $(window).width() < 681) {
      this.mobile_screen = true;
    } else {
      this.mobile_screen = false;
    }
  },
  mounted: function () {
    this.isLoader = this.setskeletonLoader;
    if (this.$route.query.viewTask) {
      this.quickView();
    }
  },
  methods: {

    setPage(page) {
      this.$emit("setPage", page);
    },


    quickView(event) {
      let id = event ? event.target.dataset.id : this.$route.query.id;
      this.isLoading = true;
      this.$store.dispatch("quick_task/view", [id]).then((response) => {
        this.isLoading = false;
        this.$store.dispatch("modal/quickTaskView", {
          action: "add",
          title: "Task Details",
          formData: {
            task: response,
          },
          component: quickView,
        });
      });
    },
    edit(event) {
      this.isLoading = true;
      this.$store.dispatch("quick_task/edit", [event.target.dataset.id]).then((response) => {
        this.isLoading = false;
        this.$store.dispatch("modal/quicktaskModal", {
          action: "edit",
          title: "Edit Quick Task",
          formData: {
            task: response,
          },
          component: taskForm
        });
      });
    },

    deleteTask(task) {
      this.$store.dispatch("message/update", {
        title: task.title,
        body: "Are you sure you want to delete this Task?",
        class: "danger",
        confirm: true,
      });

      this.$bus.$off("proceed");
      this.$bus.$once("proceed", () => {
        this.delete(task);
        this.$store.dispatch("message/close");
      });
    },

    delete(task) {
      this.showskLoader = true;
      this.$store
          .dispatch("quick_task/delete", task)
          .then((message) => {
            this.showskLoader = false;
            this.$toast.success(message);
            const filtersData = [this.$store.getters['quick_task/currentPage'], this.$store.getters['quick_task/filters'], []];
            this.$store.dispatch("quick_task/getAllTask", filtersData);
          })
          .catch((error) => {
            // send error message
            false
            this.$store.dispatch(
                "message/update",
                {
                  title: task.title,
                  class: "danger",
                  body: error.response.data.message,
                  errors: error.response.data.errors,
                  confirm: false,
                },
                {root: true}
            );
          });
    },

    async markCompleted(task) {
      const newStatus = task.status === 0 ? 1 : 0;
      task.status = newStatus;
      // Show loader
      this.isLoader = this.setskeletonLoader;
      console.log("status =>", task.status)
      try {
        await this.$store.dispatch('quick_task/updateTaskStatus', {taskId: task.id, status: newStatus});
        if (newStatus === 0) {
          this.$toast.success("Task Pending Successfully.");
        }else{
          this.$toast.success("Task Completed Successfully.");
        }
        this.$parent.getRecords();
      } catch (error) {
        // Handle any errors if needed
      } finally {
        // Hide loader
        this.isLoader = this.setskeletonLoader;
      }
    },

    nextPage() {
      if (this.page + 1 <= this.totalPages) {
        this.page++;
        this.$emit("setPage", this.page);
      }
    },
    previousPage() {
      if (this.page - 1 !== 0) {
        this.page--;
        this.$emit("setPage", this.page);
      }
    }
  },
};
</script>
<style>
.tooltip {
  border: 0px solid black !important;
}

.tooltip .tooltip-inner {
  max-width: 200px !important;
  padding: 0.25rem 0.5rem !important;
  color: #000000de !important;
  text-align: center !important;
  background-color: #dbddde !important;
  border-radius: 0.25rem !important;
  font-size: 12px !important;
  font-weight: 500 !important;
}

</style>
<style scoped>
.tooltip_color {
  color: #505ed4;
}

#td_span, #responsiveStatus {
  display: none !important;
}

td > p {
  margin-bottom: 0rem !important;
}

table tr td:nth-child(1) {
  width: 20% !important;
}

table tr td:nth-child(2) {
  width: 20% !important;
}

table tr td:nth-child(3) {
  width: 20% !important;
}

table tr td:nth-child(4) {
  width: 9% !important;
}

table tr td:nth-child(5) {
  width: 9% !important;
}

table tr td:nth-child(6) {
  width: 9% !important;
}

table tr td:nth-child(7) {
  width: 8% !important;
}

table tr td:nth-child(8) {
  width: 5% !important;
}

#table_row td p {
  margin-bottom: 0rem !important;
}

@media (min-width: 320px) and (max-width: 680px) {
  .style-action, .tooltip {
    z-index: 1 !important;
  }

  #table_row td p {
    margin-bottom: 1rem !important;
  }

  #table_row td #statusHeading {
    margin-bottom: -0.4rem !important;
  }

  #td_span, #responsiveStatus {
    display: block !important;
  }

  #responsive_status {
    display: block !important;


  }

  #responsive_status span {
    color: white;
    font-size: 10px;
    background: #fc5d60;
    height: 21px;
    width: auto;
    padding: 9% 9% !important;
    margin-top: 4px !important;

  }

  #support_table_header, #status {
    display: none;
  }

  #dataTable, #table_body {
    display: block !important;
    width: 100% !important;
  }

  #table_body {
    padding: 0% 2.5%
  }

  #table_row {
    display: flex;
    /* border-top: 1px solid lightgray; */
    flex-wrap: wrap;
    border: 1px solid lightgrey;
    border-radius: 0.3rem;
    margin-bottom: 10px;
  }

  #table_row td {
    padding-left: 2% !important;
    font-weight: 500px;
    border-top: 0px !important;
    padding-right: 0px;
    padding-bottom: 0px;
  }

  table tr td:nth-child(1) {
    width: 40% !important;
    order: 1;
    font-size: 10px !important;
  }

  table tr td:nth-child(2) {
    width: 26% !important;
    order: 2;
    font-size: 10px !important;
  }

  table tr td:nth-child(3) {
    width: 23% !important;
    order: 4;
    font-size: 10px !important;
    margin-top: -7% !important;
    /* padding-bottom: 12px !important; */
  }

  table tr td:nth-child(4) {
    width: 25% !important;
    order: 5;
    font-size: 10px !important;
    margin-top: -7% !important;
    /* padding-bottom: 12px !important; */
    /* z-index: 1; */
  }

  table tr td:nth-child(5) {
    width: 25% !important;
    order: 6;
    font-size: 10px !important;
    margin-top: -7% !important;
    /* padding-bottom: 12px !important; */
  }

  table tr td:nth-child(6) {
    width: 25% !important;
    order: 7;
    font-size: 10px !important;
    margin-top: -7% !important;
    /* padding-bottom: 12px !important; */
  }

  table tr td:nth-child(7) {
    width: 22% !important;
    font-size: 8px !important;
    padding-right: 0px;
    text-align: center;
    order: 3;
  }

  table tr td:nth-child(8) {
    width: 5% !important;
    order: 3;
    font-size: 10px !important;
    padding-left: 0% !important;
    padding-top: 0% !important;
    padding-bottom: 5% !important;
  }

  table tr td:nth-child(2) p, table tr td:nth-child(4) p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  #action_button {
    color: #6e737c;
    transform: rotate(90deg);
    margin-top: 11px;
  }

  table tr td:not(:nth-child(1)) p {
    color: #62626e !important;
    font-weight: bold;
    overflow: hidden !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
  }

  table tr td:nth-child(1) p {
    color: #3571a1 !important;
    font-weight: bold;
    overflow: hidden !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
  }

  #font_size {
    font-size: 12px !important;
  }

  .pr-5, .px-5 {
    padding-right: 0.5rem !important;
  }

  .change_page a:hover {
    background-color: #ddd !important;
    color: black;
  }

  .change_page .previous {
    background-color: #f1f1f1;
    color: black;
  }

  .change_page .next {
    background-color: #04AA6D !important;
    color: white;
    margin-left: 4% !important;
  }

  .change_page a {
    text-decoration: none;
    display: inline-block;
    padding: 8px 16px;
  }

  .pagination {
    display: none !important;
  }

  .table {
    border-bottom: 0px !important;
  }

  .border-top {
    border-top: 0px !important;
  }

  .display_rows {
    display: none !important;;
  }

  .change_page {
    display: block !important;
    width: 57% !important;
  }

  .table-responsive {
    margin-top: 109px !important;
  }

  #statusHeading {
    color: #9a9aa1;
    margin-bottom: -1rem !important;
    padding-left: 14% !important;
  }

  #responsiveStatus .dropdown-item {
    margin-bottom: 0.1rem !important;
  }

  .btn:focus, .btn.focus {
    box-shadow: 0 0 0 0rem !important;
  }

  .loader_responsive {
    margin: 0rem 0.7rem;
    padding: 0.5rem 0.5rem 0.2rem 0.5rem;
    border: 1px solid lightgrey;
    border-radius: 0.3rem;
  }
}

@media (min-width: 427px) and (max-width: 680px) {
  #table_body {
    margin-top: 2% !important;
  }

}

@media only screen and (min-width: 1280px) and (max-width: 1724px) {
  td {
    font-size: 12px;
  }

  table tr td:nth-child(1) {
    width: 18% !important;
  }

  table tr td:nth-child(2) {
    width: 18% !important;
  }

  table tr td:nth-child(3) {
    width: 18% !important;
  }

  table tr td:nth-child(4) {
    width: 11% !important;
  }

  table tr td:nth-child(5) {
    width: 13% !important;
  }

  table tr td:nth-child(6) {
    width: 10% !important;
  }

  table tr td:nth-child(7) {
    width: 14% !important;
  }

  table tr td:nth-child(8) {
    width: 1% !important;
  }
}

.quick-task-item {
  display: flex;
  align-items: center;
  padding: 0px 22px 0px 22px;
  //border: 1px solid #ddd;
  //border-radius: 5px;
  //background-color: #f9f9f9;
  margin-top: 5px;
  margin-bottom: 5px;
  font-family: Arial, sans-serif;
  color: #333;
}

.quick-task-checkbox {
  margin-left: auto;
  cursor: pointer;
  transform: scale(1.2);
}

/* Loader styles */
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.spinner {
  //border: 8px solid #f3f3f3;
  //border-top: 8px solid #48a6a6;
  //border-radius: 50%;
  color: #48a6a6;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Fade effect */
.fade-content {
  opacity: 0.5;
  pointer-events: none; /* Optional: Disable interactions while loading */
}
</style>